/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'user-messages': {
    width: 31,
    height: 31,
    viewBox: '0 0 31 31',
    data: '<g _fill="#FFD400" fill-rule="evenodd"><circle pid="0" fill-opacity=".146" cx="15.5" cy="15.5" r="15.5"/><path pid="1" d="M8.981 19.338c-.061.483-.136.971-.204 1.447-.077.548-.15 1.094-.23 1.668l.15-.01a419.4 419.4 0 012.94-.403.476.476 0 01.273.053 7.51 7.51 0 0010.661-9.101 7.479 7.479 0 00-11.128-3.783c-2.051 1.32-3.186 3.247-3.412 5.676a7.287 7.287 0 00.901 4.233.403.403 0 01.05.22zm9.583-4.697a.864.864 0 11-.005 1.728.864.864 0 01.005-1.728zm-3.054 0a.864.864 0 110 1.728.864.864 0 010-1.728zm-3.04 0a.864.864 0 11-.612.251.863.863 0 01.613-.251z"/></g>'
  }
})
